export const update = () => {
    return {
        type: 'UPDATE_SHEET'
    }
}


// WEBPACK FOOTER //
// ./src/actions/sheet.js